export default __webpack_public_path__ + "images/078ee6f085fc01407593f80ab6a0b5d1.png";